export default "__VITE_ASSET__CKSuTjkX__"